import { gql } from '@apollo/client'

// query name added, will appear as listAssets in asset manager
export default gql(`
  query listVirtualAssets($slug: String! $project: String $module: String) {
    listAssets(
      filter: {
        slug: {
          exact: $slug
        }
      }
      project: $project
      module: $module
    ) {
      items {
        id
        slug
      }
    }
  }`
)
